import React from 'react';
import { Gem } from 'lucide-react';

interface VetrinaBadgeProps {
  label?: string;
}

const VetrinaBadge: React.FC<VetrinaBadgeProps> = ({ label = '' }) => (
  <div className="bg-gradient-to-r from-yellow-400 to-yellow-600 text-white text-xs px-3 py-1 rounded-full flex items-center z-10 shadow-lg border border-yellow-300">
    <Gem className="h-3 w-3 mr-1" />
    {label}
  </div>
);

export default VetrinaBadge;
